import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Page } from '../../../../../../../models/page';
import { PageService } from '../../../../../../../services/page.service';
import { Helpers } from '../../../../../../../helpers';
import { BaseComponent } from '../../../../base.component';
import { PublisherDetailTab } from '../../../../owner/publisher-detail/publisher-detail.component';
import { DataService } from '../../../../../../../_services/data.service';
import { Paths } from '../../../../../../../models/enums';

@Component({
    selector: 'app-page',
    templateUrl: './update-page.component.html',
    encapsulation: ViewEncapsulation.None
})
export class UpdatePageComponent extends BaseComponent implements OnInit {
    returnUrl: any;
    page: Page = new Page();
    siteId: string;
    publisherName: string;

    constructor(
        private pageService: PageService,
        private router: Router,
        private dataService: DataService,
        route: ActivatedRoute
    ) {
        super();
        this.page.id = route.snapshot.params.id;
        this.returnUrl = route.snapshot.queryParams.returnUrl;
        this.siteId = route.snapshot.queryParams.siteId;
        this.publisherName = route.snapshot.queryParams.publisherName;
        this.buildBreadcrumb(route);
    }

    buildBreadcrumb(route) {
        route.snapshot.parent.data.breadcrumb = route.snapshot.queryParams.siteName;
        route.snapshot.parent.data.queryParams = { siteId: this.siteId };
        route.snapshot.parent.data.url = '/' + route.snapshot.queryParams.returnUrl;
        route.snapshot.parent.parent.data.url =
            '/' + route.snapshot.queryParams.returnUrl;
        if (this.dataService.path == Paths.Owner) {
            route.snapshot.parent.data.queryParams.tab = PublisherDetailTab.Inventory;
            route.snapshot.parent.parent.data.breadcrumb = this.publisherName;
            route.snapshot.parent.parent.data.queryParams = {
                name: this.publisherName
            };
        }
    }

    ngOnInit() {
        this.getPage();
    }

    getPage() {
        Helpers.setLoading(true);
        this.pageService.find(this.page.id).subscribe(res => {
            this.page = res.data;
            Helpers.setLoading(false);
        });
    }

    navigate() {
        let queryParams = {
            siteId: this.page.siteId,
            pageId: this.page.id
        };
        if (this.dataService.path == Paths.Owner) {
            queryParams['tab'] = PublisherDetailTab.Inventory;
            queryParams['name'] = this.publisherName;
        }
        this.router.navigate([this.returnUrl], {
            queryParams: queryParams
        });
    }

    validate(event) {
        var customRules = this.validationService.customRules;
        return this.validationService.validate(event, {
            rules: {
                name: customRules.requiredText
            }
        });
    }

    updatePage() {
        var _self = this;
        Helpers.setLoading(true);
        this.pageService.update(_self.page).subscribe(() => {
            Helpers.setLoading(false);
            this.swalService.successUpdate();
            setTimeout(function() {
                _self.navigate();
            }, 1000);
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/shared/inventory/page/update-page/update-page.component.ts